module.exports = __webpack_public_path__ + "img/ir.669a0498.svg";